import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { selectedYachtState } from '../../../redux/slices/yachtSlice';
import { toast } from 'react-toastify';

export interface IProtectedNavData {
    to: string;
    labelOrElement: string | React.JSX.Element;
    endItem?: React.JSX.Element;
    textSize?: string;
}

const ProtectedNav = (props: IProtectedNavData) => {
    const { endItem, to, labelOrElement, textSize } = props;
    const currentSelectedYachtState = useSelector(selectedYachtState);
    
     if (!currentSelectedYachtState) {
        return <div
            className={`justify-center text-gray-800 ${textSize ?? 'text-sm'} font-normal font-['Inter'] leading-tight clickable`}
            onClick={() => {
                toast.error('Please select Yacht first!!!');
            }}
        >{labelOrElement}</div>;
    }

    return (
        <NavLink to={to} className={`justify-center text-gray-800 ${textSize ?? 'text-sm'} font-normal font-['Inter'] leading-tight`}>
            {labelOrElement}
            {endItem}
        </NavLink>
    );
};

export default ProtectedNav;